import { FC, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";

const ProductMeasurementsClothing: FC<DataTableType> = (
  props: DataTableType
) => {
  const user = useSelector((state: any) => state.auth.user);
  const columnDefinition: IColumn[] = [
    // {
    //   name: "Id",
    //   accessor: "Id",
    //   editable: false,
    //   keyField: true,
    //   customClass: 'customVisibilty'
    // },
    {
      name: "Item Number",
      accessor: "SainId",
    },
    {
      name: "Display Item Number",
      accessor: (rowData: any) => {
        return {
          value: rowData?.SkuNumber ? rowData?.SkuNumber : rowData?.CatNumber,
        };
      },
    },
    {
      name: "Description",
      accessor: "Description",
    },
    {
      name: "UOM",
      accessor: (rowData: any) => {
        return {
          value:
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_SKU ||
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_PACK
              ? `CS${rowData?.PackSize}`
              : rowData?.Alias === UI_CONSTANTS.ARGOS
              ? `EA`
              : rowData?.PackSize,
        };
      },
    },
    {
      name: "Product Group",
      accessor: "ProductType",
    },
    {
      name: "Case TI",
      accessor: "CaseTi",
    },
    {
      name: "Case HI",
      accessor: "CaseHi",
    },
    {
      name: "Case H (cm)",
      accessor: "CaseH",
    },
    {
      name: "Family Group",
      accessor: "FamilyGroup",
    },

    {
      name: "Case Pack Size (UOM)",
      accessor: "UnitOfMeasure",
    },

    {
      name: "Pick Pack",
      accessor: "PickPack",
    },
    {
      name: "Each TI",
      accessor: "Ti",
    },
    {
      name: "Each HI",
      accessor: "EachHi",
    },

    {
      name: "Break Pack TI",
      accessor: "BreakPackTi",
    },
    {
      name: "Break Pack HI",
      accessor: "BreakPackHi",
    },
    {
      name: "Break Pack Indicator",
      accessor: "BreakPackIndicator",
    },
    {
      name: "Break Pack Qty",
      accessor: "BreakPackQty",
    },
    {
      name: "Each H (cm)",
      accessor: "EachH",
    },
    {
      name: "Each L (cm)",
      accessor: "EachL",
    },
    {
      name: "Each Width (cm)",
      accessor: "EachWidth",
    },
    {
      name: "Each Weight (kg)",
      accessor: "EachWeight",
    },

    {
      name: "Case L (cm)",
      accessor: "EachL",
    },
    {
      name: "Case Width (cm)",
      accessor: "EachWidth",
    },
    {
      name: "Case Weight (kg)",
      accessor: "CaseWeight",
    },
    {
      name: "Break Pack Case H (cm)",
      accessor: "BreakPackCaseH",
    },
    {
      name: "Break Pack Case L (cm)",
      accessor: "BreakPackCaseL",
    },
    {
      name: "Break Pack Case Width (cm)",
      accessor: "BreakPackCaseWidth",
    },
    {
      name: "Break Pack Case Weight (kg)",
      accessor: "BreakPackCaseWeight",
    },
    {
      name: "Grab In A Box",
      accessor: "GrabBox",
    },
  ];

  if (user?.isLDMService) {
    columnDefinition.push({
      name: "",
      accessor: "",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.searchProductData(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default ProductMeasurementsClothing;
